import React, { FC } from 'react';
import { TypeReplacementPartsProductsPageData } from '@/app/[locale]/(shop)/account/replacement-parts/fetchPageData';
import { TypeReplacementPartsFields } from '@/core/generated-types';
import { Link } from '@/navigation';
import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';
import Image from 'next/image';
import { getAssetForProduct } from '@/lib/api/productCatalog/helpers/playKitProductAssetHelpers';
import { setLocalStorage } from '@/utils/localStorage';

interface ReplacementPartsProductsProps extends TypeReplacementPartsFields {
  data: TypeReplacementPartsProductsPageData;
}

const ReplacementPartsProducts: FC<ReplacementPartsProductsProps> = ({
  data,
  title,
  description,
}) => {
  return (
    <>
      <div className="mb-10 text-center md:text-left">
        {title && (
          <Heading
            tag={HeadingTag.H2}
            size={HeadingSize.H2}
            text={title}
            classes="mb-6"
          />
        )}
        {description && <p className="text-lg leading-6">{description}</p>}
      </div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {data?.products?.map(({ product, contentfulProduct }) => {
          const {
            name,
            external_id,
            anchor,
            display_age_range: displayAgeRange,
            metadata,
          } = product;
          const ageDescription = contentfulProduct?.fields?.ageDescription;
          const asset = getAssetForProduct(product);
          const ageRange =
            metadata.data?.age_tagline || ageDescription || displayAgeRange;
          return (
            <Link
              key={external_id}
              href={`/account/replacement-parts/${anchor}`}
              className="hover:text-indigo-dark"
              onClick={() =>
                setLocalStorage('replacementPartsProduct', product)
              }
            >
              {asset ? (
                <div className="relative bg-khaki-tint">
                  <Image
                    src={asset.uri}
                    alt={asset.alt_text || `${name} image`}
                    height={240}
                    width={320}
                    className="mx-auto h-[240px] object-contain"
                  />
                </div>
              ) : null}
              <div className="mt-3">
                <p className="text-lg font-bold">{name}</p>
                <p>{ageRange}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </>
  );
};

export default ReplacementPartsProducts;
